import React from "react";
import { Transition } from "react-transition-group";
import { useOnClickOutside } from "@avamae/hooks";
import Cross from "assets/images/Icon_Modal_Cross.png";
import { AppState } from "../../reducers/rootReducer";
import { useSelector, useDispatch } from "react-redux";
import { SelectInputField } from "../BaseUIComponents/SelectInput/SelectInput";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { dateObjectToString } from "../../helpers/dates";
import { DateTimeRangeField } from "../FormComponents/FilterDatePicker/FilterDatePicker";

type UsersFilterProps = {
  table: any;
};

const UsersFilter: React.FC<UsersFilterProps> = ({
  table
}) => {
  const bind = useOnClickOutside(() => dispatch({ type: "CLOSE_RIGHT_POP_OUT" }));
  const rightPopOutState = useSelector((state: AppState) => state.rightPopOutReducer)
  const dispatch = useDispatch()

  const handleSubmit = async (values: any, setFieldError: any, setSubmitting: any, setStatus: any) => {
    let textValues = Object.keys(values).filter(k => !k.includes("_filter"))
    let filters = []

    for (const v of textValues) {
      if (v === "Users__AddDateUTC") {
        if (values[v]) {
          if (values[v].filters[0].value.includes("NULL")) {
            setFieldError("Users__AddDateUTC", "Please select both a start and end date")
          } else {
            filters.push(
              {
                columnKey: v,
                operator: "BETWEEN",
                value: dateObjectToString(values[v].filters[0].value)
              }
            )
          }
        }
      } else {
        if (values[v]) {
          filters.push(
            {
              columnKey: v,
              operator: values[`${v}_filter`],
              value: values[v]
            }
          )
        }
      }
    }


    if (table.data && filters.length > 0) {
      table.data.actions.setFilters(filters)
      dispatch({ type: "CLOSE_RIGHT_POP_OUT" })
    }

    if (filters.length === 0) {
      setStatus({ error: 'Error' })
    }

    /*
     {
      columnKey: string; field name
      operator: Omit<Operator, "INSTRINGARRAY">; - sort (CONTAINS)
      value: string; text value
     }
     */

  }

  const initialValues = {
    ContactDetails__FirstName: "",
    ContactDetails__FirstName_filter: "CONTAINS",
    ContactDetails__LastName: "",
    ContactDetails__LastName_filter: "CONTAINS",
    ClientUsers__AccountType: "",
    ClientUsers__AccountType_filter: "CONTAINS",
    ContactDetails__Email: "",
    ContactDetails__Email_filter: "CONTAINS",
    ClientUsers__AddDateUTC: "",
    ClientUsers__AddDateUTC_filter: "DateTime:Range",
  }

  let textFilterOptions = [{ value: "CONTAINS", label: "Contains" }, { value: "EQ", label: "Equals" }]
  let intFilterOptions = [{ value: "CONTAINS", label: "Contains" }, { value: "EQ", label: "Equals" }, { value: "GT", label: "Greater than" }, { value: "GEQ", label: "Greater or equal to" }, { value: "LT", label: "Less than" }, { value: "LEQ", label: "Less than or equal to" },]

  return (
    <Transition in={rightPopOutState.rightPopOutOpen === "USERS_FILTER"} timeout={100} mountOnEnter unmountOnExit>
      {state => (
        <>
          <div className={"RightPopOutUnderlay " + state}>
          </div>

          <div className={"RightPopOut " + state} {...bind}>
            <div className="Inner">
              <div className="Top">
                <h2 className="Title">Filter Payment Cards</h2>
                <div className="CloseButton">
                  <img className="CloseButton" alt="Logo" src={Cross} onClick={() => dispatch({ type: "CLOSE_RIGHT_POP_OUT" })} />
                </div>
              </div>
              <div className="Children">
                <Formik
                  initialValues={initialValues}
                  onSubmit={(values, { setFieldError, setSubmitting, setStatus }) => {
                    handleSubmit(values, setFieldError, setSubmitting, setStatus)
                  }}
                  render={({ isValid, values, isSubmitting, status }) => (
                    <Form>
                      <div className={`PaymentCardFilter`}>
                        {status && status.error && <div className="ErrorMessageLeft" style={{ marginBottom: "5px" }}>Please complete at least one filter type</div>}
                        <div className="FormBox">
                          <div className="FormSideBySide NoMargin">
                            <div className="FormLabel FormLabelFilters">
                              <label>First name</label>
                            </div>
                            <div className="FormField FormFieldFilters">
                              <SelectInputField
                                options={textFilterOptions}
                                name="ContactDetails__FirstName_filter"
                                placeholder="Contains"
                                errors={[]}
                              />
                            </div>
                            <div className="FormField FormFieldFilters">
                              <Field
                                type="text"
                                name="ContactDetails__FirstName"
                                id="ContactDetails__FirstName"
                                className="EditBox"
                              />
                            </div>
                          </div>

                          <div className="FormSideBySide NoMargin">
                            <div className="FormLabel FormLabelFilters">
                              <label>Last name</label>
                            </div>
                            <div className="FormField FormFieldFilters">

                              <SelectInputField
                                options={textFilterOptions}
                                name="ContactDetails__LastName_filter"
                                placeholder="Contains"
                                errors={[]}
                              />
                            </div>
                            <div className="FormField FormFieldFilters">
                              <Field
                                type="text"
                                name="ContactDetails__LastName"
                                id="ContactDetails__LastName"
                                className="EditBox"
                              />
                            </div>
                          </div>

                          <div className="FormSideBySide NoMargin">
                            <div className="FormLabel FormLabelFilters">
                              <label>Account type</label>
                            </div>
                            <div className="FormField FormFieldFilters">
                              <SelectInputField
                                options={intFilterOptions}
                                name="ClientUsers__AccountType_filter"
                                placeholder="Contains"
                                errors={[]}
                              />
                            </div>
                            <div className="FormField FormFieldFilters">
                              <Field
                                type="text"
                                name="ClientUsers__AccountType"
                                id="ClientUsers__AccountType"
                                className="EditBox"
                              />
                            </div>
                          </div>

                          <div className="FormSideBySide NoMargin">
                            <div className="FormLabel FormLabelFilters">
                              <label>Email</label>
                            </div>
                            <div className="FormField FormFieldFilters">
                              <SelectInputField
                                options={intFilterOptions}
                                name="ContactDetails__Email_filter"
                                placeholder="Contains"
                                errors={[]}
                              />
                            </div>
                            <div className="FormField FormFieldFilters">
                              <Field
                                type="text"
                                name="ContactDetails__Email"
                                id="ContactDetails__Email"
                                className="EditBox"
                              />
                            </div>
                          </div>

                          <div className="FormSideBySide">
                            <DateTimeRangeField
                              name="ClientUsers__AddDateUTC"
                              label="Add date range"
                            />
                          </div>
                          <ErrorMessage name={"ClientUsers__AddDateUTC"} component="div">
                            {msg => <div className="ErrorMessageLeft">{msg}</div>}
                          </ErrorMessage>
                        </div>
                      </div>
                      <div className="Bottom">
                        <button className="Btn BtnWhite" onClick={() => dispatch({ type: "CLOSE_RIGHT_POP_OUT" })}>
                          Cancel
                        </button>
                        <button className="Btn" type="submit">
                          Filter
                        </button>
                      </div>
                    </Form>
                  )}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </Transition>
  )
}

export default UsersFilter;